export const tooltips = {
  averageResponses:
    'This metric shows the average number of responses provided by the AI per call, indicating how interactive and responsive the AI is.',
  handlingTime:
    'This metric reflects the average time the AI takes to handle a call, showcasing the efficiency of the AI in managing inquiries.',
  responseTime:
    "This metric measures the average time it takes for the AI to respond to a query, indicating the speed of the AI's responses.",
};
